// extracted by mini-css-extract-plugin
export default {"userContent":"UserProfile_userContent__HhC1H","descriptionContainer":"UserProfile_descriptionContainer__hPhqh","name":"UserProfile_name__P1b2G"};